import React from 'react';

export default function WoodenWheelSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Shadow */}
      <ellipse cx="20" cy="38" rx="12" ry="2" fill="#3E2723" opacity="0.12" />
      {/* Outer rim */}
      <circle cx="20" cy="20" r="16" fill="#A67C52" />
      <circle cx="20" cy="20" r="14.5" fill="#C49A6C" />
      {/* Inner groove */}
      <circle cx="20" cy="20" r="12.5" fill="none" stroke="#A67C52" strokeWidth="1" opacity="0.4" />
      {/* Spokes */}
      <line x1="20" y1="7" x2="20" y2="33" stroke="#A67C52" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="7" y1="20" x2="33" y2="20" stroke="#A67C52" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="10.8" y1="10.8" x2="29.2" y2="29.2" stroke="#A67C52" strokeWidth="2" strokeLinecap="round" />
      <line x1="29.2" y1="10.8" x2="10.8" y2="29.2" stroke="#A67C52" strokeWidth="2" strokeLinecap="round" />
      {/* Spoke highlights */}
      <line x1="20" y1="7.5" x2="20" y2="33" stroke="#D4AA7A" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
      <line x1="7.5" y1="20" x2="33" y2="20" stroke="#D4AA7A" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
      {/* Center hub */}
      <circle cx="20" cy="20" r="5" fill="#8D6E63" />
      <circle cx="20" cy="20" r="3.8" fill="#A1887F" />
      <circle cx="20" cy="20" r="2" fill="#6D4C41" />
      {/* Hub bolt highlight */}
      <circle cx="20" cy="19.5" r="1" fill="#B8885A" />
      {/* Metal rim band */}
      <circle cx="20" cy="20" r="15.8" fill="none" stroke="#90A4AE" strokeWidth="1.5" />
      <circle cx="20" cy="20" r="15.8" fill="none" stroke="#B0BEC5" strokeWidth="0.5" />
      {/* Shine */}
      <path d="M12 10C10 13 9 16 9 20" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.12" />
    </svg>
  );
}
